<template>
  <div>
    <p class="titleModal">
      {{ $t('forms.labels.treatment') }}
    </p>
    <VTextField
      v-model="data.treatment"
      :label="$t('forms.labels.treatment')"
      :rules="{ required: true, min: 1, max: 200 }"
      outlined
      data-cy="cyArTreatment"
    />
    <VTextField
      v-model="data.otherTreatment"
      :label="$t('forms.labels.otherTreatment')"
      :rules="{ max: 1000 }"
      data-cy="cyArOtherTreatment"
      outlined
    />
  </div>
</template>

<script>
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';

export default {
    components: {
        VTextField,
    },
    props: {
        analysisRequest: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            data: {
                treatment: this.analysisRequest.treatment,
                otherTreatment: this.analysisRequest.otherTreatment,
            },
        };
    },
    watch: {
        data: {
            handler() {
                this.$emit('updateData', this.data);
            },
            deep: true,
        },
    },
};
</script>
